module.exports = __webpack_public_path__ + "static/media/windows-download.9ec21dd2.svg";